import { Logger } from '@ori/logger';
import { APP_NAME } from '@ori/novage-skincare-advisor';

export const mainLogger = new Logger(`${APP_NAME}-app`);
